exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3uIsYSNLnse546gM1Zm3Sw{display:flex;flex-direction:column;align-items:center}._1TATb6DBkkI2QsBtBcKI5S{height:90px;display:flex;align-items:center;margin-top:12vh;font-size:16px;font-family:\"comic sans ms\", sans-serif}\n", ""]);
// Exports
exports.locals = {
	"main": "_3uIsYSNLnse546gM1Zm3Sw",
	"header": "_1TATb6DBkkI2QsBtBcKI5S"
};